import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';

const ChannelTalkModal = () => {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      if (e.detail?.url) setUrl(e.detail.url);
    };
    window.addEventListener('ieum:open-channel-talk', handler);
    return () => window.removeEventListener('ieum:open-channel-talk', handler);
  }, []);

  if (!url) return null;

  return (
    <Overlay onClick={() => setUrl(null)}>
      <Modal onClick={(e) => e.stopPropagation()}>
        <Header>
          <Title>채팅상담</Title>
          <CloseBtn type="button" onClick={() => setUrl(null)} aria-label="닫기">
            <IoClose size={22} />
          </CloseBtn>
        </Header>
        <Frame src={url} title="ChannelTalk" allow="microphone; clipboard-read; clipboard-write" />
      </Modal>
    </Overlay>
  );
};

export default ChannelTalkModal;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 20px;
`;

const Modal = styled.div`
  position: relative;
  background: #fff;
  border-radius: 14px;
  width: 100%;
  max-width: 480px;
  height: min(720px, 90vh);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 12px 36px rgba(0, 0, 0, 0.18);

  @media (max-width: 600px) {
    max-width: 100%;
    height: 90vh;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  border-bottom: 1px solid #E5E7EB;
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: #111827;
`;

const CloseBtn = styled.button`
  background: none;
  border: 0;
  padding: 4px;
  cursor: pointer;
  color: #6B7280;
  display: inline-flex;
  align-items: center;
  &:hover { color: #111827; }
`;

const Frame = styled.iframe`
  flex: 1;
  width: 100%;
  border: 0;
`;
